export enum Page {
  Costs = 'costs',
  Data = 'data',
  DocumentAndSectionTemplates = 'documentAndSectionTemplates',
  ExternalThirdParties = 'externalThirdParties',
  Folder = 'folder',
  FolderBusinessEvents = 'folderBusinessEvents',
  FolderFiles = 'folderFiles',
  FolderMissions = 'folderMissions',
  Folders = 'folders',
  Gis = 'gis',
  Home = 'home',
  InternalThirdParties = 'internalThirdParties',
  LocalityInfos = 'localityInfos',
  Materials = 'materials',
  Mission = 'mission',
  MissionAccounting = 'missionAccounting',
  MissionBusinessEvents = 'missionBusinessEvents',
  MissionFiles = 'missionFiles',
  MissionQuotation = 'missionQuotation',
  MissionReport = 'missionReport',
  MissionServiceUsages = 'missionServiceUsages',
  MissionSubMissions = 'missionSubMissions',
  MissionToolkits = 'missionToolkits',
  References = 'references',
  // The entries of the menu mission space that does not hold the current
  // mission: the collaboration of the current sub-mission, or the sub-mission
  // space while no sub-mission is open.
  RelatedMission = 'relatedMission',
  RelatedMissionAccounting = 'relatedMissionAccounting',
  RelatedMissionBusinessEvents = 'relatedMissionBusinessEvents',
  RelatedMissionFiles = 'relatedMissionFiles',
  RelatedMissionQuotation = 'relatedMissionQuotation',
  RelatedMissionReport = 'relatedMissionReport',
  RelatedMissionServiceUsages = 'relatedMissionServiceUsages',
  RelatedMissionSubMissions = 'relatedMissionSubMissions',
  RelatedMissionToolkits = 'relatedMissionToolkits',
  ResolvableMissionTypes = 'resolvableMissionTypes',
  ResolvableServices = 'resolvableServices',
  Unregistered = 'unregistered',
  Users = 'users',
  Workflows = 'workflows',
}
